module.exports = __webpack_public_path__ + "static/nz-fitness-gear-611085f1eeb829b0e8e6251e8fced37a.png";